/** @format */

// TODO: Refactor this component. It was written using a very old pattern.

import {AddSizeLarge} from '../assets/icons/Add_Size_Large.jsx';
import {AddSizeMedium} from '../assets/icons/Add_Size_Medium.jsx';
import {AddSizeSmall} from '../assets/icons/Add_Size_Small.jsx';
import {AmexSmall} from '../assets/icons/Amex_Small.jsx';
import {AmexMedium} from '../assets/icons/Amex_Medium.jsx';
import {AmexLarge} from '../assets/icons/Amex_Large.jsx';
import {ArrowDownLarge} from '../assets/icons/Arrow_Down_Large.jsx';
import {ArrowDownMedium} from '../assets/icons/Arrow_Down_Medium.jsx';
import {ArrowDownSmall} from '../assets/icons/Arrow_Down_Small.jsx';
import {ArrowLeftLarge} from '../assets/icons/Arrow_Left_Large.jsx';
import {ArrowLeftMedium} from '../assets/icons/Arrow_Left_Medium.jsx';
import {ArrowLeftSmall} from '../assets/icons/Arrow_Left_Small.jsx';
import {ArrowRightLarge} from '../assets/icons/Arrow_Right_Large.jsx';
import {ArrowRightMedium} from '../assets/icons/Arrow_Right_Medium.jsx';
import {ArrowRightSmall} from '../assets/icons/Arrow_Right_Small.jsx';
import {ArrowUpLarge} from '../assets/icons/Arrow_Up_Large.jsx';
import {ArrowUpMedium} from '../assets/icons/Arrow_Up_Medium.jsx';
import {ArrowUpSmall} from '../assets/icons/Arrow_Up_Small.jsx';
import {CartLarge} from '../assets/icons/Cart_Large.jsx';
import {CartMedium} from '../assets/icons/Cart_Medium.jsx';
import {CartSmall} from '../assets/icons/Cart_Small.jsx';
import {ChatLarge} from '../assets/icons/Chat_Large.jsx';
import {ChatMedium} from '../assets/icons/Chat_Medium.jsx';
import {ChatSmall} from '../assets/icons/Chat_Small.jsx';
import {CheckLarge} from '../assets/icons/Check_Large.jsx';
import {CheckMedium} from '../assets/icons/Check_Medium.jsx';
import {CheckSmall} from '../assets/icons/Check_Small.jsx';
import {CloseLarge} from '../assets/icons/Close_Large.jsx';
import {CloseMedium} from '../assets/icons/Close_Medium.jsx';
import {CloseSmall} from '../assets/icons/Close_Small.jsx';
import {DiscoverSmall} from '../assets/icons/Discover_Small.jsx';
import {DiscoverMedium} from '../assets/icons/Discover_Medium.jsx';
import {DiscoverLarge} from '../assets/icons/Discover_Large.jsx';
import {EditLarge} from '../assets/icons/Edit_Large.jsx';
import {EditMedium} from '../assets/icons/Edit_Medium.jsx';
import {EditSmall} from '../assets/icons/Edit_Small.jsx';
import {EnvelopeLarge} from '../assets/icons/Envelope_Large.jsx';
import {EnvelopeMedium} from '../assets/icons/Envelope_Medium.jsx';
import {EnvelopeSmall} from '../assets/icons/Envelope_Small.jsx';
import {FacebookLarge} from '../assets/icons/Facebook_Large.jsx';
import {FacebookMedium} from '../assets/icons/Facebook_Medium.jsx';
import {FacebookSmall} from '../assets/icons/Facebook_Small.jsx';
import {GoogleLarge} from '../assets/icons/Google_Large.jsx';
import {GoogleMedium} from '../assets/icons/Google_Medium.jsx';
import {GoogleSmall} from '../assets/icons/Google_Small.jsx';
import {HideSmall} from '../assets/icons/Hide_Small';
import {HideMedium} from '../assets/icons/Hide_Medium';
import {HideLarge} from '../assets/icons/Hide_Large';
import {InfoLarge} from '../assets/icons/Info_Large.jsx';
import {InfoMedium} from '../assets/icons/Info_Medium.jsx';
import {InfoSmall} from '../assets/icons/Info_Small.jsx';
import {InstagramLarge} from '../assets/icons/Instagram_Large.jsx';
import {InstagramMedium} from '../assets/icons/Instagram_Medium.jsx';
import {InstagramSmall} from '../assets/icons/Instagram_Small.jsx';
import {LinkedinLarge} from '../assets/icons/Linkedin_Large.jsx';
import {LinkedinMedium} from '../assets/icons/Linkedin_Medium.jsx';
import {LinkedinSmall} from '../assets/icons/Linkedin_Small.jsx';
import {MasterCardSmall} from '../assets/icons/MasterCard_Small.jsx';
import {MasterCardMedium} from '../assets/icons/MasterCard_Medium.jsx';
import {MasterCardLarge} from '../assets/icons/MasterCard_Large.jsx';
import {MenuLarge} from '../assets/icons/Menu_Large.jsx';
import {MenuMedium} from '../assets/icons/Menu_Medium.jsx';
import {MenuSmall} from '../assets/icons/Menu_Small.jsx';
import {NavigateDownLarge} from '../assets/icons/Navigate_Down_Large.jsx';
import {NavigateDownMedium} from '../assets/icons/Navigate_Down_Medium.jsx';
import {NavigateDownSmall} from '../assets/icons/Navigate_Down_Small.jsx';
import {NavigateLeftLarge} from '../assets/icons/Navigate_Left_Large.jsx';
import {NavigateLeftMedium} from '../assets/icons/Navigate_Left_Medium.jsx';
import {NavigateLeftSmall} from '../assets/icons/Navigate_Left_Small.jsx';
import {NavigateRightLarge} from '../assets/icons/Navigate_Right_Large.jsx';
import {NavigateRightMedium} from '../assets/icons/Navigate_Right_Medium.jsx';
import {NavigateRightSmall} from '../assets/icons/Navigate_Right_Small.jsx';
import {NavigateUpLarge} from '../assets/icons/Navigate_Up_Large.jsx';
import {NavigateUpMedium} from '../assets/icons/Navigate_Up_Medium.jsx';
import {NavigateUpSmall} from '../assets/icons/Navigate_Up_Small.jsx';
import {NotificatoinLarge} from '../assets/icons/Notificatoin_Large.jsx';
import {NotificatoinMedium} from '../assets/icons/Notificatoin_Medium.jsx';
import {NotificatoinSmall} from '../assets/icons/Notificatoin_Small.jsx';
import {PhoneLarge} from '../assets/icons/Phone_Large.jsx';
import {PhoneMedium} from '../assets/icons/Phone_Medium.jsx';
import {PhoneSmall} from '../assets/icons/Phone_Small.jsx';
import {PinterestLarge} from '../assets/icons/Pinterest_Large.jsx';
import {PinterestMedium} from '../assets/icons/Pinterest_Medium.jsx';
import {PinterestSmall} from '../assets/icons/Pinterest_Small.jsx';
import {PrintLarge} from '../assets/icons/Print_Large.jsx';
import {PrintMedium} from '../assets/icons/Print_Medium.jsx';
import {PrintSmall} from '../assets/icons/Print_Small.jsx';
import {SearchLarge} from '../assets/icons/Search_Large.jsx';
import {SearchMedium} from '../assets/icons/Search_Medium.jsx';
import {SearchSmall} from '../assets/icons/Search_Small.jsx';
import {ShieldMedium} from '../assets/icons/Shield_Medium.jsx';
import {ShippingLarge} from '../assets/icons/Shipping_Large.jsx';
import {ShippingMedium} from '../assets/icons/Shipping_Medium.jsx';
import {ShippingSmall} from '../assets/icons/Shipping_Small.jsx';
import {StarLarge} from '../assets/icons/Star_Large.jsx';
import {StarMedium} from '../assets/icons/Star_Medium.jsx';
import {StarSmall} from '../assets/icons/Star_Small.jsx';
import {TrashLarge} from '../assets/icons/Trash_Large.jsx';
import {TrashMedium} from '../assets/icons/Trash_Medium.jsx';
import {TrashSmall} from '../assets/icons/Trash_Small.jsx';
import {TwitterLarge} from '../assets/icons/Twitter_Large.jsx';
import {TwitterMedium} from '../assets/icons/Twitter_Medium.jsx';
import {TwitterSmall} from '../assets/icons/Twitter_Small.jsx';
import {UserLarge} from '../assets/icons/User_Large.jsx';
import {UserMedium} from '../assets/icons/User_Medium.jsx';
import {UserSmall} from '../assets/icons/User_Small.jsx';
import {ViewLarge} from '../assets/icons/View_Large.jsx';
import {ViewMedium} from '../assets/icons/View_Medium.jsx';
import {ViewSmall} from '../assets/icons/View_Small.jsx';
import {VisaSmall} from '../assets/icons/Visa_Small.jsx';
import {VisaMedium} from '../assets/icons/Visa_Medium.jsx';
import {VisaLarge} from '../assets/icons/Visa_Large.jsx';
import {WarningLarge} from '../assets/icons/Warning_Large.jsx';
import {WarningMedium} from '../assets/icons/Warning_Medium.jsx';
import {WarningSmall} from '../assets/icons/Warning_Small.jsx';
import {XLarge} from '../assets/icons/X_Large.jsx';
import {XMedium} from '../assets/icons/X_Medium.jsx';
import {XSmall} from '../assets/icons/X_Small.jsx';
import {ZoomInLarge} from '../assets/icons/Zoom_In_Large.jsx';
import {ZoomInMedium} from '../assets/icons/Zoom_In_Medium.jsx';
import {ZoomInSmall} from '../assets/icons/Zoom_In_Small.jsx';
import {AutoRenew} from '../assets/icons/Autorenew.jsx';

export const Icon = ({name, color = '#FFFFFF', small, medium, large}) => {
    !small && !large && !medium ? (medium = true) : (medium = medium); // set medium as default
    const filter = name ? name.toLowerCase() : 'undefiend';
    switch (filter) {
        case 'add':
            if (large) return <AddSizeLarge color={color} />;
            if (medium) return <AddSizeMedium color={color} />;
            if (small) return <AddSizeSmall color={color} />;

        case 'amex':
            if (large) return <AmexLarge />;
            if (medium) return <AmexMedium />;
            if (small) return <AmexSmall />;

        case 'arrowdown':
            if (large) return <ArrowDownLarge color={color} />;
            if (medium) return <ArrowDownMedium color={color} />;
            if (small) return <ArrowDownSmall color={color} />;

        case 'arrowleft':
            if (large) return <ArrowLeftLarge color={color} />;
            if (medium) return <ArrowLeftMedium color={color} />;
            if (small) return <ArrowLeftSmall color={color} />;

        case 'arrowright':
            if (large) return <ArrowRightLarge color={color} />;
            if (medium) return <ArrowRightMedium color={color} />;
            if (small) return <ArrowRightSmall color={color} />;

        case 'arrowup':
            if (large) return <ArrowUpLarge color={color} />;
            if (medium) return <ArrowUpMedium color={color} />;
            if (small) return <ArrowUpSmall color={color} />;

        case 'autorenew':
            return <AutoRenew color={color} small={small} large={large} medium={medium} />;

        case 'cart':
            if (large) return <CartLarge color={color} />;
            if (medium) return <CartMedium color={color} />;
            if (small) return <CartSmall color={color} />;

        case 'chat':
            if (large) return <ChatLarge color={color} />;
            if (medium) return <ChatMedium color={color} />;
            if (small) return <ChatSmall color={color} />;

        case 'check':
            if (large) return <CheckLarge color={color} />;
            if (medium) return <CheckMedium color={color} />;
            if (small) return <CheckSmall color={color} />;

        case 'close':
            if (large) return <CloseLarge color={color} />;
            if (medium) return <CloseMedium color={color} />;
            if (small) return <CloseSmall color={color} />;

        case 'discover':
            if (large) return <DiscoverLarge />;
            if (medium) return <DiscoverMedium />;
            if (small) return <DiscoverSmall />;

        case 'edit':
            if (large) return <EditLarge color={color} />;
            if (medium) return <EditMedium color={color} />;
            if (small) return <EditSmall color={color} />;

        case 'envelope':
            if (large) return <EnvelopeLarge color={color} />;
            if (medium) return <EnvelopeMedium color={color} />;
            if (small) return <EnvelopeSmall color={color} />;

        case 'facebook':
            if (large) return <FacebookLarge color={color} />;
            if (medium) return <FacebookMedium color={color} />;
            if (small) return <FacebookSmall color={color} />;

        case 'google':
            if (large) return <GoogleLarge color={color} />;
            if (medium) return <GoogleMedium color={color} />;
            if (small) return <GoogleSmall color={color} />;

        case 'hide':
            if (large) return <HideLarge color={color} />;
            if (medium) return <HideMedium color={color} />;
            if (small) return <HideSmall color={color} />;

        case 'info':
            if (large) return <InfoLarge color={color} />;
            if (medium) return <InfoMedium color={color} />;
            if (small) return <InfoSmall color={color} />;

        case 'instagram':
            if (large) return <InstagramLarge color={color} />;
            if (medium) return <InstagramMedium color={color} />;
            if (small) return <InstagramSmall color={color} />;

        case 'linkedin':
            if (large) return <LinkedinLarge color={color} />;
            if (medium) return <LinkedinMedium color={color} />;
            if (small) return <LinkedinSmall color={color} />;

        case 'mastercard':
            if (large) return <MasterCardLarge />;
            if (medium) return <MasterCardMedium />;
            if (small) return <MasterCardSmall />;

        case 'menu':
            if (large) return <MenuLarge color={color} />;
            if (medium) return <MenuMedium color={color} />;
            if (small) return <MenuSmall color={color} />;

        case 'navigatedown':
            if (large) return <NavigateDownLarge color={color} />;
            if (medium) return <NavigateDownMedium color={color} />;
            if (small) return <NavigateDownSmall color={color} />;

        case 'navigateleft':
            if (large) return <NavigateLeftLarge color={color} />;
            if (medium) return <NavigateLeftMedium color={color} />;
            if (small) return <NavigateLeftSmall color={color} />;

        case 'navigateright':
            if (large) return <NavigateRightLarge color={color} />;
            if (medium) return <NavigateRightMedium color={color} />;
            if (small) return <NavigateRightSmall color={color} />;

        case 'navigateup':
            if (large) return <NavigateUpLarge color={color} />;
            if (medium) return <NavigateUpMedium color={color} />;
            if (small) return <NavigateUpSmall color={color} />;

        case 'notification':
            if (large) return <NotificatoinLarge color={color} />;
            if (medium) return <NotificatoinMedium color={color} />;
            if (small) return <NotificatoinSmall color={color} />;

        case 'phone':
            if (large) return <PhoneLarge color={color} />;
            if (medium) return <PhoneMedium color={color} />;
            if (small) return <PhoneSmall color={color} />;

        case 'pinterest':
            if (large) return <PinterestLarge color={color} />;
            if (medium) return <PinterestMedium color={color} />;
            if (small) return <PinterestSmall color={color} />;

        case 'print':
            if (large) return <PrintLarge color={color} />;
            if (medium) return <PrintMedium color={color} />;
            if (small) return <PrintSmall color={color} />;

        case 'search':
            if (large) return <SearchLarge color={color} />;
            if (medium) return <SearchMedium color={color} />;
            if (small) return <SearchSmall color={color} />;

        case 'shield':
            if (medium) return <ShieldMedium color={color} />;

        case 'shipping':
            if (large) return <ShippingLarge color={color} />;
            if (medium) return <ShippingMedium color={color} />;
            if (small) return <ShippingSmall color={color} />;

        case 'star':
            if (large) return <StarLarge color={color} />;
            if (medium) return <StarMedium color={color} />;
            if (small) return <StarSmall color={color} />;

        case 'trash':
            if (large) return <TrashLarge color={color} />;
            if (medium) return <TrashMedium color={color} />;
            if (small) return <TrashSmall color={color} />;

        case 'twitter':
            if (large) return <TwitterLarge color={color} />;
            if (medium) return <TwitterMedium color={color} />;
            if (small) return <TwitterSmall color={color} />;

        case 'user':
            if (large) return <UserLarge color={color} />;
            if (medium) return <UserMedium color={color} />;
            if (small) return <UserSmall color={color} />;

        case 'view':
            if (large) return <ViewLarge color={color} />;
            if (medium) return <ViewMedium color={color} />;
            if (small) return <ViewSmall color={color} />;

        case 'visa':
            if (large) return <VisaLarge />;
            if (medium) return <VisaMedium />;
            if (small) return <VisaSmall />;

        case 'warning':
            if (large) return <WarningLarge color={color} />;
            if (medium) return <WarningMedium color={color} />;
            if (small) return <WarningSmall color={color} />;

        case 'x':
            if (large) return <XLarge color={color} />;
            if (medium) return <XMedium color={color} />;
            if (small) return <XSmall color={color} />;

        case 'zoomin':
            if (large) return <ZoomInLarge color={color} />;
            if (medium) return <ZoomInMedium color={color} />;
            if (small) return <ZoomInSmall color={color} />;

        default:
            return <></>;
    }
};
